const NUMMIN = { 
    numeroSUSEP: 0,

    ordem: 0,

    larguraLogoTopbar: 10,
    larguraLogoReport: 10,
    alturaLogoTopbar: 10,
    alturaLogoReport: 10,

    estudoReportCapaTitulo1MargemTopo: 20,
    estudoReportCapaClienteConjugeTitulo2MargemTopo: 10,
    estudoReportCapaClienteConjugeTitulo2MargemEsquerda: 0,

    backgroundPaginaRelatorioMargemEsquerdaCabecalho: 0,
    backgroundPaginaRelatorioMargemTopoRodape: -10,

    margemTop: -280,
    margemLeft: 0,
    
    diasAntecedenciaEnvioLembreteAporte: 1,
    
    idade: 0,
    idadeNascimento: -10,

    tempoMinimoEntreAportesResgatesCalculoIRAnos: 1,

    qtdeDependentes: 0,

    peso: 1,
    imc: 1,
    qtdeFumoSemanal: 1,
    
    perc: 0,
    percMaiorQueZero: 0.01,

    anosReajusteAumento: 1,

    dia: 1,
    dias: 0,
    mes: 1,
    ano: 2000,
    meses: 1,
    anos: 1,

    mesesDevolucaoFundoReserva: 1,
    mesesIniciarAluguelAposContemplacao: 1,
    mesesVendaAposQuitacao: 1,

    anoComissao: 1,
    percComissao: 0,

    anoMes: 190001,

    anosExibicaoRelatorioEvolucaoReservaFinanceira: 1,

    cotaConsorcio: 1,
    numeroAssembleiaParticipacao: 1,
    prazoTotalGrupoConsorcio: 1,
    prazoTotalCotaConsorcio: 1,
    numeroTotalParticipantesGrupoConsorcio: 1,

    percRentabilidadeRecursoFinanceiro: -100,

    taxa: 0.01,
    taxaNegativa: -99.99,
    percIR: 10,

    qtdeParcelas: 1,
    numeroCobertura: 1,
    processoSeguradora: 1,

    duracaoPremioExtra: 1,

    ultimaVersao: 1,

    qtdeClientes: 0,
    qtdeTransacoes: 0,
}

export default NUMMIN